import { render, staticRenderFns } from "./FormCreateTask.vue?vue&type=template&id=28c5ca42&"
import script from "./FormCreateTask.vue?vue&type=script&lang=js&"
export * from "./FormCreateTask.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports